import {invoiceConstants} from '../constants';

const invoiceState = {
  invoicesListUrl: undefined,
  invoicesListQuery: undefined,
  invoicesListTableData: undefined,
  invoicesListTabKey: undefined,
  // Set once an invoice was updated or deleted on the details page, so the list page
  // refetches instead of restoring the cached rows as they are.
  invoicesListRequiresUpdate: false,
};

const invoiceReducer = (state = invoiceState, action) => {
  const {type} = action;
  switch (type) {
    case invoiceConstants.SAVE_INVOICES_LIST_URL:
      return {
        ...state,
        invoicesListUrl: action?.payload?.url,
        invoicesListQuery: action?.payload?.query,
        invoicesListTableData: action?.payload?.tableData,
        invoicesListTabKey: action?.payload?.tabKey,
        invoicesListRequiresUpdate: false,
      }
    case invoiceConstants.CLEAR_INVOICES_LIST_TABLE_DATA:
      return {
        ...state,
        invoicesListTableData: undefined,
        invoicesListTabKey: undefined,
        invoicesListRequiresUpdate: false,
      }
    case invoiceConstants.CLEAR_INVOICES_DATA:
      return invoiceState
    case invoiceConstants.PATCH_INVOICES_LIST_ROW: {
      const updatedInvoice = action?.payload;
      if (!updatedInvoice?.id || !state.invoicesListTableData?.rows) return state;
      return {
        ...state,
        invoicesListTableData: {
          ...state.invoicesListTableData,
          rows: state.invoicesListTableData.rows.map(
            row => row.id === updatedInvoice.id ? updatedInvoice : row
          ),
        },
        // Any update can move the invoice out of (or back into) the list the user came
        // from, and the filter set keeps growing, so never trust the patched row: mark
        // the snapshot stale and let the list page refetch from the backend.
        invoicesListRequiresUpdate: true,
      }
    }
    case invoiceConstants.SET_INVOICES_LIST_REQUIRES_UPDATE:
      return {
        ...state,
        invoicesListRequiresUpdate: true,
      }
    default:
      return state
  }
};

export default invoiceReducer;
